import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ESignService {

  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  fetchEsignReceipt(esignType: string, key: number) {
    return this.httpClient.get<{ status: string; depKey: number, esignType: string, errorMessage: string }>(
      ApiUrls.esignReceipt.replace('{esignType}', esignType.toString()).replace('{key}', key.toString())
    );
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

}
